import { render, staticRenderFns } from "./VarietyCampaignTotalsTable.vue?vue&type=template&id=f7646440&"
import script from "./VarietyCampaignTotalsTable.vue?vue&type=script&lang=js&"
export * from "./VarietyCampaignTotalsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports